import React, { useState } from 'react';
import './DeleteLogEntryModal.css';

const DeleteLogEntryModal = ({ isOpen, onClose, onConfirm, entry, metric }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setLoading(true);
    setError('');

    try {
      await onConfirm(entry.id);
      onClose();
    } catch (error) {
      setError(error.message || 'Failed to delete entry');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setError('');
      onClose();
    }
  };

  if (!isOpen) return null;

  const formatDate = (entry) => {
    return new Date(entry.createdAt).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Delete Entry</h3>
          <button 
            className="modal-close-btn"
            onClick={handleClose}
            disabled={loading}
          >
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="entry-preview">
            <div className="entry-details">
              <div className="entry-date">{formatDate(entry)}</div>
              <div className="entry-value">
                {metric?.type === 'numeric' ? `${entry.value} ${metric.unit}` : entry.value}
              </div>
              {entry.notes && (
                <div className="entry-notes">{entry.notes}</div>
              )}
            </div>
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="cancel-btn"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="delete-btn"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Delete Entry'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteLogEntryModal;
